if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.addEventListener('DOMContentLoaded', function() {
        const toggleButtonReserve = document.getElementById("btn-reserve");
        const formContainer = document.querySelector('.form-container');
        const textReserve = document.getElementById("btn-reserve");
        if(toggleButtonReserve){
            toggleButtonReserve.addEventListener("click", function() {
                if (formContainer.classList.contains("active")) {
                    textReserve.textContent = "start planning";
                    formContainer.classList.remove("active");
                    toggleButtonReserve.classList.remove("active");
                } else {
                    textReserve.textContent = "close";
                    formContainer.classList.add("active");
                    toggleButtonReserve.classList.add("active");
                }
            });
        }

        const mobileButton = document.getElementById('menu-btn');
        const mobileText = document.getElementById('menu-btn__text');
        const mobileNav = document.querySelector('.mobile-nav');
        if (mobileButton) {
            mobileButton.addEventListener('click', function(){
                if (mobileNav.classList.contains("active")) {
                    mobileText.textContent = "menu";
                    mobileNav.classList.remove("active");
                    mobileButton.classList.remove("active");
                } else {
                    mobileText.textContent = "close";
                    mobileNav.classList.add("active");
                    mobileButton.classList.add("active");
                }
            });
        }

        let scrollButtons = document.querySelectorAll('.js-scroll');
        if(scrollButtons.length > 0){
            scrollButtons.forEach((scroll)=>{
                scroll.addEventListener('click', (e)=>{
                    e.preventDefault();
                    let data = scroll.getAttribute('href').split('#')[1];
                    let target = document.getElementById(data);
                    let headerHeight = document.querySelector('header').offsetHeight;
                    console.log(data);
                    window.scrollTo({
                        top: target.offsetTop - headerHeight,
                        behavior: 'smooth'
                    });
                });
            });
        }

        const intro = document.getElementById("intro");
        let extendIntro = document.getElementsByClassName("extend-intro");
        extendIntro = extendIntro[extendIntro.length - 1];

        if (extendIntro) {
            extendIntro.classList.add("enabled");
    
            const extendIntroOffset = () => {
                extendIntro.style.setProperty("--offset", extendIntro.offsetTop - intro.offsetTop + 'px');
            }
    
            extendIntroOffset();
            
            window.addEventListener("resize", extendIntroOffset);
        }

    });
    
    // $('.sym-slides.slider').slick("refresh");

    //tabs table funcionality
	document.querySelectorAll('[data-goto]').forEach((btn, i) => {
		btn.addEventListener('click', e => {
				document.querySelectorAll('[data-goto]').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('[data-target]').forEach( item => {
					item.classList.remove('active');
					if (btn.dataset.goto === item.dataset.target ) item.classList.add('active');
				});

		});
		
		if (i === 0) btn.click()
	});

	const select_tab = document.querySelector('[data-tabselect]');
	if (select_tab != null) {
		select_tab.addEventListener('change', e => {
			document.querySelectorAll('[data-target]').forEach(item => {
				item.classList.remove('active');
				if (select_tab.value === item.dataset.target) {
					item.classList.add('active');
				}
			});
		});
	}
    // table section
	const tablesResp = document.querySelectorAll('.rental-rates__right table');
	if (tablesResp.length) {
			tablesResp.forEach((tablei) => {
					let tableresponsive = document.createElement('div')
					tableresponsive.classList.add('tableHold')
					tablei.parentNode.insertBefore(tableresponsive, tablei)
					tableresponsive.append(tablei)
					const ths = tablei.querySelectorAll('tr:first-child > *')
					tablei.querySelectorAll('tr + tr').forEach((row) => {
							const tds = row.querySelectorAll('td')
							let i = 0
							for (i; i < tds.length; i++) {
									tds[i].setAttribute('data-label', ths[i].textContent)
							}
					})
					const rowHeads = tablei.querySelectorAll('tr td:first-child')
					rowHeads.forEach((ele) => {
							ele.addEventListener('click', (ev) => {
									ele.closest('tr').classList.toggle('active')
							})
					})
			})
	}

})();